import { ChangeRegionDialogContainer } from './ChangeRegionDialogContainer.tsx';
import { mountDialogUIReactComponent } from '../../ui_platform/mountDialogUIReactComponent.tsx';
export const showChangeRegionDialog = mountDialogUIReactComponent(ChangeRegionDialogContainer);
